import { render, staticRenderFns } from "./preTestGate.vue?vue&type=template&id=753a0321&"
import script from "./preTestGate.vue?vue&type=script&lang=js&"
export * from "./preTestGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports